import { Box, Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ADDRESS, MAIL_HOME_ADDR_SAME, PHYSICAL_ADDRESS, REQUIRED } from '../../constants';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { CustomAutoComplete } from '../LeadGeneration/CustomAutoComplete/CustomAutoComplete';
import CustomSwitch from '../LeadGeneration/Switch/CustomSwitch';
import CustomTooltip from '../Tooltip/CustomTooltip';
import { LayoutStyles as classes } from './LayoutStyles';
import { isBundle } from '../commonCode';

function AddressInfo() {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { addressInformation, addressInformationErrors } = leadGenerationContext;
  const { t } = useTranslation();
  return (
    <Grid container style={{ width: '100%' }} data-page="address-info">
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <CustomAutoComplete
          id="address1"
          dataTestIdAutocomplete="autocomplete_address1"
          dataTestIdForLabel="homeAddress1"
          dataTestIdForInput="addr1Input"
          required
          inputLabelAriaLabel={` ${t(PHYSICAL_ADDRESS, {
            defaultValue: PHYSICAL_ADDRESS,
          })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
          label={t(PHYSICAL_ADDRESS, {
            defaultValue: PHYSICAL_ADDRESS,
          })}
          bundleAddress
          isBundle={isBundle(leadGenerationContext.productName)}
          disabledAddressBundle
          value={(addressInformation?.fullAddress || '').trimStart()}
          options={[]}
          filterOptions={(options) => options}
          maxLength={30}
          placeholder={t('Enter Home Address Details', {
            defaultValue: 'Enter Home Address Details',
          })}
          fullWidth
          error={addressInformationErrors?.address1}
        />
      </Grid>
    </Grid>
  );
}

export default AddressInfo;
